import type { ReactNode } from 'react'
import { pageLeadClass, pageTitleClass, sectionTitleClass } from '../../lib/ui'

type Props = {
  title: ReactNode
  lead?: ReactNode
  asSection?: boolean
}

export function PageHeader({ title, lead, asSection }: Props) {
  return (
    <header className="mb-5">
      <h2 className={asSection ? sectionTitleClass : pageTitleClass}>{title}</h2>
      {lead ? <p className={pageLeadClass}>{lead}</p> : null}
    </header>
  )
}
